module.exports = __webpack_public_path__ + "assets/myTeam.e8904cf0.svg";